import React from "react";
import {
  AutocompleteArrayInput,
  AutocompleteInput,
  useDataProvider,
} from "react-admin";
import { useLocation } from "react-router";
import { useFormContext } from "react-hook-form";

const DynamicDropdownFilter = ({
  label,
  source,
  resource,
  allowTextInput,
}: {
  label: string;
  source: string;
  resource: string;
  allowTextInput?: boolean;
}) => {
  const [choices, setChoices] = React.useState<{ id: string; name: string }[]>(
    []
  );
  const dataProvider = useDataProvider();

  const location = useLocation();
  const sourceValueFromLocation = location.state?.record?.[source];
  const { setValue } = useFormContext();
  React.useEffect(() => {
    setValue(source, sourceValueFromLocation);
  }, [source, setValue, sourceValueFromLocation]);

  React.useEffect(() => {
    const fetchUniqueValues = async () => {
      try {
        const response = await dataProvider.getUnique(resource, {
          field: source,
        });
        setChoices(
          response.map((value: string) => ({
            id: value,
            name: value,
          }))
        );
      } catch (error) {
        console.error("Error fetching unique values:", error);
      }
    };

    fetchUniqueValues();
  }, [dataProvider, resource, source]);

  return allowTextInput ? (
    <AutocompleteArrayInput
      label={label}
      source={source}
      onCreate={(newTagName: string | undefined) => {
        if (newTagName) {
          const newTag = { id: newTagName, name: newTagName };
          setChoices((prevChoices) => [...prevChoices, newTag]);
          return newTag;
        }
      }}
      choices={choices.map((choice, index) => ({
        ...choice,
        key: `${choice.id}-${index}`,
      }))}
    />
  ) : (
    <AutocompleteInput
      label={label}
      source={source}
      choices={choices.map((choice, index) => ({
        ...choice,
        key: `${choice.id}-${index}`,
      }))}
    />
  );
};

export default DynamicDropdownFilter;
